import 'reflect-metadata';
import './css/global.scss';
import '@getaccept/lib-shared/src/polyfills';
import '@getaccept/lib-shared/src/bugsnag';
import Vue from 'vue';
import vTooltip from 'v-tooltip';
import LibUi from '@getaccept/lib-ui';
import App from './App.vue';
import router from './router/router';
import i18n from './i18n/lang';
import 'focus-visible';
import './init.ts';

Vue.config.productionTip = false;

Vue.use(vTooltip, { defaultHtml: false });
Vue.use(LibUi);

setTimeout(() => {
  new Vue({
    router,
    i18n,
    render: h => h(App),
  }).$mount('#login');
});
